import { render, staticRenderFns } from "./InfraServices.vue?vue&type=template&id=176fc407&"
import script from "./InfraServices.vue?vue&type=script&lang=js&"
export * from "./InfraServices.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports